import { actionTypes, mutationTypes, getterTypes } from '../../../types';

const threshold = 10;
let scrollStart = 0;
let $scrollWrapper = null;
let store = null;

function setupWrapper($scrollWrapper) {
	$scrollWrapper.addEventListener('scroll', scrollListener);
	$scrollWrapper.addEventListener('touchstart', onTouchStart);
	$scrollWrapper.addEventListener('keydown', onKeyDown);
	$scrollWrapper.addEventListener('wheel', onWeel);
	$scrollWrapper.addEventListener('mousedown', onMouseDown);
}

function tearDownWrapper($scrollWrapper) {
	$scrollWrapper.removeEventListener('scroll', scrollListener);
	$scrollWrapper.removeEventListener('touchstart', onTouchStart);
	$scrollWrapper.removeEventListener('keydown', onKeyDown);
	$scrollWrapper.removeEventListener('wheel', onWeel);
	$scrollWrapper.removeEventListener('mousedown', onMouseDown);
}

function scrollListener() {
	// if body is scrolling different naming of fields
	const curScrollPos = $scrollWrapper === window ? window.scrollY : $scrollWrapper.scrollTop;
	const scrollHeight =
		$scrollWrapper === window ? window.document.body.scrollHeight : $scrollWrapper.scrollHeight;
	const topBottomThreshold = 40;
	if ((scrollStart > curScrollPos + threshold || curScrollPos < 1) && store.state.legacyDown) {
		onScroll('up');
	} else if (scrollStart < curScrollPos - threshold) {
		onScroll('down');
	}
	if (
		curScrollPos >= scrollHeight - screen.height - topBottomThreshold ||
		scrollHeight <= screen.height // set to bottom if article height is smaller then body height
	) {
		if (store.state.position !== 'bottom') {
			return store.commit(mutationTypes.scrollSetPosition, 'bottom');
		}
		return;
	}
	if (curScrollPos <= topBottomThreshold) {
		if (store.state.position !== 'top') {
			return store.commit(mutationTypes.scrollSetPosition, 'top');
		}
		return;
	}
	if (store.state.position !== 'between') {
		return store.commit(mutationTypes.scrollSetPosition, 'between');
	}
}

function updateScrollStart() {
	if ($scrollWrapper === window) {
		scrollStart = Math.min(
			Math.max($scrollWrapper.scrollY, 0),
			window.document.body.scrollHeight - screen.height
		);
	} else
		scrollStart = Math.min(
			Math.max($scrollWrapper.scrollTop, 0),
			$scrollWrapper.scrollHeight - $scrollWrapper.clientHeight
		);
}

function onScroll(scrollDirection) {
	if (store.state.direction !== scrollDirection) {
		store.commit(mutationTypes.scrollSetDirection, scrollDirection);
	}

	const scrolledDown = scrollDirection === 'down';
	if (scrolledDown === store.state.legacyDown) {
		return;
	}

	// Don't hide if scrolled down less than top nav height.
	const uiTop = document.querySelector('.ui--top');
	const parallaxFactor = store.rootState.navigation.theme === 'topic' ? 1.5 : 1;
	const scrollPostion = window ? $scrollWrapper.scrollY : $scrollWrapper.scrollTop;
	if (uiTop && scrollPostion < uiTop.clientHeight * parallaxFactor && scrollDirection === 'down') {
		return;
	}
	updateScrollStart();
	store.commit(mutationTypes.toggleScrolledDown, { scrolledDown });
}

// Scroll and key listerners listener for hiding an showing navigationsbars on different cases of scrolling
function onTouchStart() {
	updateScrollStart();
}

function onWeel(event) {
	if (event.deltaY) {
		onScroll(parseInt(event.deltaY) > 0 ? 'down' : 'up');
	}
}

function onMouseDown() {
	updateScrollStart();
}

// Scrolling on keys
function onKeyDown(event) {
	if (event.key == 'ArrowUp' || event.key == 'PageUp') {
		onScroll('up');
	}
	if (event.key == 'ArrowDown' || event.key == 'PageDown') {
		onScroll('down');
	}
}

export default {
	state: {
		// new scroll direction and position state
		position: 'top', // ['top', 'between', 'bottom']
		direction: 'up',
		pageScrollPositions: {},
		legacyDown: false,
	},
	mutations: {
		[mutationTypes.scrollSetPosition](state, position) {
			state.position = position;
		},
		[mutationTypes.scrollSetDirection](state, direction) {
			state.direction = direction;
		},
		[mutationTypes.toggleScrolledDown](state, { scrolledDown }) {
			state.legacyDown = scrolledDown;
		},
		[mutationTypes.scrollSavePagePosition](state, { articleID, exhibitionID, scroll }) {
			state.pageScrollPositions = {
				...state.pageScrollPositions,
				[`${exhibitionID}/${articleID}`]: scroll,
			};
		},
	},
	actions: {
		[actionTypes.scrollSetWrapper](_store, $newScrollWrapper) {
			store = _store;
			if ($scrollWrapper) tearDownWrapper($scrollWrapper);
			setupWrapper($newScrollWrapper);
			$scrollWrapper = $newScrollWrapper;
			scrollListener();
		},
	},
	getters: {
		[getterTypes.getScrolledArticlePosition](state, getters, rootState) {
			return ({ exhibitionID, articleID, historyKey }) => {
				const historyEntry = rootState.history.map[historyKey];
				const historyScroll = !!historyEntry && historyEntry.scroll;
				// If this article is reached by browser history restore scroll if not restore only if alwaysRestoreSCroll is on
				if (typeof historyScroll === 'number') {
					return historyScroll;
				}
				// Prevent crash if configWebClient is empty object
				return (rootState.dataSourceCFG.configWebClient.navigation || {}).alwaysRestoreScroll
					? state.pageScrollPositions[`${exhibitionID}/${articleID}`] || 0
					: 0;
			};
		},
	},
};
